import React, {Component} from "react"
import {connect} from "react-redux"
import {injectIntl} from 'react-intl'
import {Button, Modal, ModalBody} from "react-bootstrap"
import $ from 'jquery'
import 'cropper/dist/cropper.min'
import 'cropper/dist/cropper.css'
import {alert, alertSuccess} from '../util/AlertUtil'
import config from "../config"
import Alert from './Alert'

const imageSizeLimit = 500 //k

const api_server_host = config.api_server_host

function mapStateToProps(state, ownProps) {

  const user = state.user

  return {
    user
  }

}

const mapDispatchToProps = {

}

class ImageUploadModal extends Component {

  constructor(){
    super()
    this.state = {
      fileLoaded: false,
      loading: false,
      error: null,
      message: null
    }
  }

  initCropper(component) {

    const _this = component
    const format = _this.props.intl.formatMessage
    const user = _this.props.user
    const token = user.access_token
    const type = user.token_type

    const default_image = _this.props.defaultImage

    var $image = $(".image-crop > img")


    $($image).cropper({
      aspectRatio: 1,
      preview: ".img-preview",
      done: function (data) {
        // Output the result data for cropping image.
      }
    });

    $image.prop('src', default_image)

    let fileExtension = null
    var $inputImage = $("#inputImage");
    if (window.FileReader) {
      $inputImage.change(function () {

        var fileReader = new FileReader(),
          files = this.files,
          file;

        if (!files.length) {
          return;
        }

        file = files[0];

        if (/^image\/\w+$/.test(file.type)) {
          fileExtension = file.type.split('\/')[1]
          fileReader.readAsDataURL(file);
          fileReader.onload = function () {
            $inputImage.val("");
            $image.cropper("reset", true).cropper("replace", this.result);
            _this.setState({fileLoaded: true})

          };

        } else {
          alert(format({id:'alert.choose.image'}));
        }
      });
    } else {
      $inputImage.addClass("hide");
    }

    $($image).on('cropend', (e)=>{

      $image.cropper("getCroppedCanvas").toBlob(function (blob) {
        component.setState({imageSize:blob.size})
      })
    })

    $("#upload").click(function () {
      $image.cropper("getCroppedCanvas").toBlob(function (blob) {

        if(blob.size < imageSizeLimit*8*1000){

          var formData = new FormData();

          formData.append('image', blob);
          const path = _this.props.uploadPath.replace('{fileExtension}', fileExtension)

          _this.setState({loading: true})

          $.ajax(`${api_server_host}${path}`, {
            method: "POST",
            data: formData,
            headers:{Authorization: `${type} ${token}`},
            processData: false,
            contentType: false,
            success: function () {
              if(_this.props.success)
                _this.props.success()
              _this.setState({
                loading: false,
                // message: 'Image uploaded.'
              })
              alertSuccess("Image Uploaded!")
            },
            error: function (jqXHR) {
              _this.setState({
                loading: false,
                alert: JSON.parse(jqXHR.responseText)
              })
            }
          })

        }else{
          alert(format({id:'alert.image.size'}, {imageSize:Math.round(blob.size/8000)}))
        }


      })
    });


  }

  render() {

    const format = this.props.intl.formatMessage


    return (
      <Modal bsSize="lg"
             onEntered={()=>{
               this.initCropper(this)
               this.setState({
                 imageSize:null,
                 fileLoaded: false,
                 message: null
               })
             }}
             show={this.props.show} onHide={this.props.onHide}>
        <Modal.Header closeButton>
          <h2>{this.props.title}</h2>
        </Modal.Header>

        <Modal.Body className="gray-bg" style={{height:300}}>

          <div className="row">
            <div className="col-md-4">
              <p>{format({id:'add.image.desc'}, {imageSizeLimit})} </p>
              {this.state.imageSize?<p>{format({id:'current.size'})}: {Math.round(this.state.imageSize/8000)}k</p>:''}
              <label title="Upload image file" for="inputImage"
                     className={`m-r-xs btn btn-primary ${this.state.loading ? 'disabled' : ''}`}>
                <input type="file" accept="image/*" name="file" id="inputImage" className="hide"></input>
                {format({id:'select.file'})}
              </label>
            </div>
            <div className="col-md-8">
              <div className="image-crop">
                <img style={{maxWidth:'100%', height:'260px'}}></img>
                <div className="img-preview hidden"/>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={this.props.onHide}>
            {format({id:'cancel'})}
          </Button>
          <label title="Upload image" id="upload"
                 className={`btn btn-primary ${this.state.loading || !this.state.imageSize || this.state.imageSize > imageSizeLimit*8*1000 || !this.state.fileLoaded ? 'disabled' : ''}`}>
            {format({id:'save'})}
          </label>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ImageUploadModal))



// WEBPACK FOOTER //
// ./src/components/ImageUploadModal.js